import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getAllOrganizations } from '../../../api/organizations';

import {
  checkAndSetLoading,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

import { REQUEST } from '../../../constants/request';

export const fetchAllOrganizations = createAsyncThunk(
  `organizations/fetchAllOrganizations`,
  async ({ params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getAllOrganizations(
        { params },
        {
          cancelToken: source.token,
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState();

      return (
        state.organizations.organizations.allOrganizations.request.loading !==
        REQUEST.pending
      );
    },
  },
);

export const fetchAllOrganizationsExtraReducers = builder => {
  builder
    .addCase(fetchAllOrganizations.pending, (state, action) => {
      checkAndSetLoading(state.organizations.allOrganizations.request, action);
    })
    .addCase(fetchAllOrganizations.fulfilled, (state, action) => {
      onMatchedRequest(
        state.organizations.allOrganizations.request,
        action,
        () => {
          action.payload.forEach(organization => {
            state.organizations.organization.byId[organization.id] =
              organization;
            if (
              !state.organizations.organization.allIds.includes(organization.id)
            ) {
              state.organizations.organization.allIds.push(organization.id);
            }
          });
          state.organizations.allOrganizations.layout.push(...action.payload);
        },
      );
    })
    .addCase(fetchAllOrganizations.rejected, (state, action) => {
      handleRequestRejection(
        state.organizations.allOrganizations.request,
        action,
      );
    });
};
